<template>
   <BreadCrumb PageTitle="Détails d'un support de cours" />
    <ViewSupport/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ViewSupport from "@/components/SupportDeCours/ViewSupport.vue";

    export default defineComponent({
      name: "ViewSupportPage",
      components: {
        BreadCrumb,
        ViewSupport,
      },
    });
  </script>